import type { ChassisAssembly, EnumElasticType } from "./generated/graphql";

export const findPartInstanceForKey = (keySplit: string[], chassisAssembly: ChassisAssembly) => {
  const partType = keySplit[1];
  const partLocation = keySplit[keySplit.length - 2];
  const partInstances = chassisAssembly?.nestedPartInstances;
  switch (partType) {
    // ALL elastics
    case "aero":
      return partInstances?.find(
        pi => pi?.specification?._id === keySplit[2], // only need the id
      );
    case "antiRollBarSpecs":
      return partInstances?.find(pi => {
        const spec = pi.specification as unknown as { __typename: string };
        return pi?.readingLocation === partLocation && spec.__typename === "AntiRollBarSpec";
      });
    case "bumpStopSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "BUMP_RUBBER",
      );
    case "custom":
      return partInstances?.find(
        pi => pi?.readingLocation === partLocation && pi?.specificationID === keySplit[2], // only need the id
      );
    case "damperSpecs":
      return partInstances?.find(pi => {
        const spec = pi.specification as unknown as { __typename: string };
        return pi?.readingLocation === partLocation && spec?.__typename === "DamperSpec";
      });
    case "droopStopSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "BUMP_RUBBER",
      );

    case "externalBumpStopSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "BUMP_RUBBER",
      );
    case "helperSpringSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "HELPER_SPRING",
      );
    case "reboundSpringSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "REBOUND_SPRING",
      );
    case "springSpecs":
      return partInstances?.find(
        pi =>
          pi?.readingLocation === partLocation &&
          (pi?.specification as { elasticType: EnumElasticType })?.elasticType === "SPRING",
      );
  }

  return undefined;
};
